// extracted by mini-css-extract-plugin
module.exports = {"dropdown":"VersionDropdown_dropdown__5wFVn","selectOption":"VersionDropdown_selectOption__Lunsl","displayText":"VersionDropdown_displayText__x6xSz"};